var scriptsJs = (function () {
  return {
    init: init,
    scriptLoaded: scriptLoaded
  };

  function init() {
    uiBindings();
  }

  function uiBindings() {
    /**
     * Polyfill for .remove() that doesnt work in IE
     * https://stackoverflow.com/questions/3387427/remove-element-by-id/18120786#18120786
     * https://developer.mozilla.org/en-US/docs/Web/API/ChildNode/remove#Browser_compatibility
     */
    (function (arr) {
      arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
          return;
        }
        Object.defineProperty(item, 'remove', {
          configurable: true,
          enumerable: true,
          writable: true,
          value: function remove() {
            if (this.parentNode === null) {
              return;
            }
            this.parentNode && this.parentNode.removeChild(this);
          }
        });
      });
    })([Element.prototype, CharacterData.prototype, DocumentType.prototype].filter(Boolean));

    /**
     * Cookie Remove Functionality
     */
    var enableCookiesRemoval = cookiesRemovalConfig.enable_cookie_removal_feature;
    if (enableCookiesRemoval) {
      var cookiesToRemove = cookiesRemovalConfig.add_cookies_to_remove;
      if (cookiesToRemove && cookiesToRemove != "") {
        var listofCookies = cookiesToRemove.split(',');
        for (var i = 0; i < listofCookies.length; i++) {
          if (getCookieVal(listofCookies[i], false) !== null) {
            setCookieVal(listofCookies[i], "", -1, false);
          }
        }
      }
    }
    
    /**
     * Expire Cookies Function
     * Not sure if we need this in WordPess or not
     */
    function expireCookies() {
      var removeCookies = [
        "signedin",
        "page_unloaded",
        "job_notify",
        "optimizelyEndUserId",
        "optimizelyBuckets",
        "_mkto_trk",
        "optimizelySegments",
      ];

      for (var i = 0, l = removeCookies.length; i < l; i++) {
        Cookie.erase(removeCookies[i]);
      }
    }

    expireCookies();

    function getQueryStringValue(key) {
      var queryString = '';
      try {
        queryString = decodeURIComponent(
          window.location.search.replace(
            new RegExp(
              "^(?:.*[&\\?]" +
                encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
                "(?:\\=([^&]*))?)?.*$",
              "i"
            ),
            "$1"
          )
        );
      } catch (e) {}

      return queryString;
    }

    /**
     * store utm params in cookie so that it can be tracked in rails
     */
    (function updateUtmCookie() {
      var src = getQueryStringValue("utm_source");
      var medium = getQueryStringValue("utm_medium");
      var campaign = getQueryStringValue("utm_campaign");

      if (src || medium || campaign) {
        var json = JSON.stringify({
          utm_source: src,
          utm_medium: medium,
          utm_campaign: campaign,
        });
        Cookie.create("utm_params", encodeURIComponent(json), 90);
      }
    })();

    var acceptCookieNotify = document.getElementById("accept-cookie-notification"),
    rejectCookieNotify = document.getElementById("reject-cookie-notification"),
    acceptCookieNotifyCross = document.getElementById("accept-cookie-notification-cross"),
    cookieNotification = document.getElementById("cookie-notification"),
    cookieHoverBool = true,
    cookieConsentInfo = Cookie.read(stage_env_cookie_prefix + 'ConsentGeoDetail') ? bsLib.JSONParse(Cookie.read(stage_env_cookie_prefix + 'ConsentGeoDetail')) : {};
    
    if (cookieNotification && acceptCookieNotify && rejectCookieNotify && acceptCookieNotifyCross && !Cookie.read(stage_env_cookie_prefix + 'UserOptCookie') && !enableTrustArcCCM) {

      //load event
      if (cookieConsentInfo.hasOwnProperty("continent") && cookieConsentInfo.showNewBanner) {
        cookieNotification.classList.remove("hide");

        loadWebTrackerEvents.push({
          eventName: "CookieConsentBannerShown",
          eventProperty: {
            region: cookieConsentInfo.region,
            continent: cookieConsentInfo.continent,
            signedin: wpUserLoggedIn
          }
        });
      } else {
        // XHR request for cookie consent
        bsLib.ajax(
          "GET",
          bsLib.railsHost() + "/user/cookie-consent-info",
          {},
          false,
          {},
          // Success message for user token.
          function(data) {
            if (data.readyState === 4 && data.status === 200) {
              var dataRes = bsLib.JSONParse(data.response);

              if (dataRes.hasOwnProperty("data")) {
                cookieConsentInfo = {
                  "showNewBanner": dataRes.data.show_cookie_consent_for_location,
                  "continent": dataRes.data.continent,
                  "region": dataRes.data.real_region_name
                };

                Cookie.create(stage_env_cookie_prefix + 'ConsentGeoDetail', JSON.stringify(cookieConsentInfo), 365);
              }

              if (cookieConsentInfo.hasOwnProperty("continent") && cookieConsentInfo.showNewBanner) {
                cookieNotification.classList.remove("hide");
                loadWebTrackerEvents.push({
                  eventName: "CookieConsentBannerShown",
                  eventProperty: {
                    region: cookieConsentInfo.region,
                    continent: cookieConsentInfo.continent,
                    signedin: wpUserLoggedIn
                  }
                });
              } else {
                Cookie.create(stage_env_cookie_prefix + 'UserOptCookie', true, 365);
              }
            }
          },
          // Custom Error message for user token.
          function() {
            return "cookie-consent-info API not working";
          }
        );
      }

      if (cookieConsentInfo.hasOwnProperty("continent") && cookieConsentInfo.showNewBanner) {
        //hover
        cookieNotification.addEventListener("mouseover", function () {
          if (cookieHoverBool) {
            WebEventTracker.logEvent(EDS.webEvents, "InteractedWithCookieConsentBanner", {
              action: 'hover',
              continent: cookieConsentInfo.hasOwnProperty("continent") ? cookieConsentInfo.continent : "",
              region: cookieConsentInfo.hasOwnProperty("region") ? cookieConsentInfo.region : "",
              signedin: wpUserLoggedIn
            });
          }

          cookieHoverBool = false;
        });

        acceptCookieNotify.addEventListener("click", function () {
          CookieManagementfunc(this, true);
        });
        rejectCookieNotify.addEventListener("click", function () {
          CookieManagementfunc(this, false);
        });
        acceptCookieNotifyCross.addEventListener("click", function () {
          if (cookieConsentInfo.hasOwnProperty("continent") && cookieConsentInfo.showNewBanner) {
            CookieManagementfunc(this, false);
          } else {
            CookieManagementfunc(this, true);
          }
        });
      }
    }
    if (!enableTrustArcCCM || wpUserLoggedIn) {
      var teconsent = document.getElementById('teconsent');
      
      if (teconsent) {
        parentLi = teconsent.closest('li');
        parentLi.remove();
      }
    }

    if (enableTrustArcCCM && !wpUserLoggedIn ) {

      var retryCount = 0;
      var maxRetries = 10;

      var trustArcInt = setInterval(function () {
        var trustArcBanner = document.getElementById('consent-banner'),
          acceptCookie = document.getElementById('truste-consent-button'),
          bannerCross = document.getElementById('truste-consent-close'),
          showConsent = document.getElementById('truste-show-consent'),
          teconsent = document.getElementById('teconsent');

        //load event
        if (trustArcBanner && trustArcBanner.childNodes.length > 0) {
          if (cookieConsentInfo.hasOwnProperty('continent')) {
            loadWebTrackerEvents.push({
              eventName: 'CookieConsentBannerShown',
              eventProperty: {
                region: cookieConsentInfo.region,
                continent: cookieConsentInfo.continent,
                signedin: wpUserLoggedIn,
              },
            });
          } else {
            // XHR request for cookie consent
            bsLib.ajax(
              'GET',
              bsLib.railsHost() + '/user/cookie-consent-info',
              {},
              false,
              {},
              // Success message for user token.
              function (data) {
                if (data.readyState === 4 && data.status === 200) {
                  var dataRes = bsLib.JSONParse(data.response);

                  if (dataRes.hasOwnProperty('data')) {
                    cookieConsentInfo = {
                      showNewBanner: dataRes.data.show_cookie_consent_for_location,
                      continent: dataRes.data.continent,
                      region: dataRes.data.real_region_name,
                    };

                    Cookie.create(stage_env_cookie_prefix + 'ConsentGeoDetail', JSON.stringify(cookieConsentInfo), 365);
                  }
                  if (cookieConsentInfo.hasOwnProperty('continent')) {
                    loadWebTrackerEvents.push({
                      eventName: 'CookieConsentBannerShown',
                      eventProperty: {
                        region: cookieConsentInfo.region ? cookieConsentInfo.region : '',
                        continent: cookieConsentInfo.continent ? cookieConsentInfo.continent : '',
                        signedin: wpUserLoggedIn,
                      },
                    });
                  }
                }
              },
              // Custom Error message for user token.
              function () {
                return 'cookie-consent-info API not working';
              }
            );
          }
          clearInterval(trustArcInt);
        } else {
          retryCount++;
          if (retryCount >= maxRetries) {
            clearInterval(trustArcInt);
          }
        }

        if (trustArcBanner && acceptCookie && bannerCross && showConsent) {
          // Hover event
          trustArcBanner.addEventListener('mouseover', function () {
            if (cookieHoverBool) {
              WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithCookieConsentBanner', {
                action: 'hover',
                continent: cookieConsentInfo.hasOwnProperty('continent') ? cookieConsentInfo.continent : '',
                region: cookieConsentInfo.hasOwnProperty('region') ? cookieConsentInfo.region : '',
                signedin: wpUserLoggedIn,
              });
            }
            cookieHoverBool = false;
          });

          // Accept cookie event
          acceptCookie.addEventListener('click', function () {
            WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithCookieConsentBanner', {
              action: 'click',
              title: 'Accept All',
              signedin: wpUserLoggedIn,
              region: cookieConsentInfo.hasOwnProperty('region') ? cookieConsentInfo.region : '',
              continent: cookieConsentInfo.hasOwnProperty('continent') ? cookieConsentInfo.continent : '',
            });
          });

          // Manage cookie event
          showConsent.addEventListener('click', function () {
            WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithCookieConsentBanner', {
              action: 'click',
              title: 'Manage Choices',
              signedin: wpUserLoggedIn,
              region: cookieConsentInfo.hasOwnProperty('region') ? cookieConsentInfo.region : '',
              continent: cookieConsentInfo.hasOwnProperty('continent') ? cookieConsentInfo.continent : '',
            });
          });

          // Close cookie banner event
          bannerCross.addEventListener('click', function () {
            WebEventTracker.logEvent(EDS.webEvents, 'InteractedWithCookieConsentBanner', {
              action: 'click',
              title: 'Cross Icon',
              signedin: wpUserLoggedIn,
              region: cookieConsentInfo.hasOwnProperty('region') ? cookieConsentInfo.region : '',
              continent: cookieConsentInfo.hasOwnProperty('continent') ? cookieConsentInfo.continent : '',
            });
          });
        }

        if (teconsent && teconsent.children.length !== 0) {
          var teConsentList = teconsent.querySelector('a');
          teConsentList.setAttribute('class', 'custom-btn-amp-events');
          teConsentList.setAttribute('role', 'button');
          teConsentList.setAttribute('data-btn-eventname', 'ClickedOnFooter');
          teConsentList.setAttribute('data-btn-ampjson', JSON.stringify({ value: 'Cookie Preference' }));
        }
      }, 500);
    }

    function CookieManagementfunc(elem, accept) {
      var eventName = 'InteractedWithCookieConsentBanner',
      eventObj= {
        action: 'click',
        title: "Accept All",
        signedin: wpUserLoggedIn,
        region: cookieConsentInfo.hasOwnProperty("region") ? cookieConsentInfo.region : "",
        continent: cookieConsentInfo.hasOwnProperty("continent") ? cookieConsentInfo.continent : ""
      },
      cookieNotification = document.getElementById("cookie-notification");

      if (cookieNotification) {
        //create cookie
        Cookie.create(stage_env_cookie_prefix + 'UserOptCookie', accept, 365);
        cookieNotification.classList.add("hide");
      }

      //Event Tracking
      if (elem.id == "accept-cookie-notification-cross") {
        eventObj.title = "Cross Icon";
      } else if (elem.id == "reject-cookie-notification") {
        eventObj.title = "Reject All";
      }

      WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);

      /**
       * Set Position of Freshchat Widget once cookie policy is accepted
       */
      if (accept) {
        window.hasOwnProperty("freshChat") ? freshChat.setFreshChatPosition() : "";
      }
    }
    /**
     * Smooth Scroll to anchor on Click
     * https://www.youtube.com/watch?v=oUSvlrDTLi4
     */

    function smoothScroll(target, duration) {
      var target = document.querySelector(target),
        headerElem = document.getElementById("header-habitat"),
        targetPosition =
          target.getBoundingClientRect().top - (headerElem ? headerElem.offsetHeight: 0) + window.pageYOffset,
        startPosition = window.pageYOffset,
        distance = targetPosition - startPosition,
        startTime = null; 

      function scrollAnimation(currentTime) {
        if (startTime === null) {
          startTime = currentTime;
        }
        var timeElapsed = currentTime - startTime;
        var run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) {
          requestAnimationFrame(scrollAnimation);
        }
      }

      /**
       * Easing Functions
       * http://www.gizma.com/easing/
       */
      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      }
      requestAnimationFrame(scrollAnimation);
    }
    var scrollClicks = document.querySelectorAll('[data-scrollto], .one-page-scroll');
    for (var k = 0; k < scrollClicks.length; k++) {
      scrollClicks[k].addEventListener('click', function (e) {
        var scrollClick = this,
          ieVersion = bsLib.msieversion();
        /**
         * Check if ie version less than 11 then dont add  e.preventDefault().
         */
        if (!ieVersion || ieVersion >= 11) {
          e.preventDefault();
        }
        var scrollTarget = scrollClick.getAttribute('data-scrollto');
        scrollTarget = !scrollTarget ? scrollClick.getAttribute('href') : scrollTarget;
        if (scrollTarget && document.querySelector(scrollTarget)) {
          smoothScroll(scrollTarget, 1000);
        }
      });
    }

    /**
     * Social Link Tracking Js
     */

    var socialLink = document.getElementsByClassName("social-link");
    if (socialLink) {
      for (var i = 0; i < socialLink.length; i++) {
        socialLink[i].addEventListener("click", socialLinkFn);
      }
    }

    function socialLinkFn() {
      var title = this.getAttribute("title");
      ga(
        "browserstack.set",
        "dimension7",
        String(Math.round(new Date() / 1000))
      );
      ga("browserstack.send", "event", {
        eventCategory: "Footer",
        eventAction: "Link Click",
        eventLabel: "Footer_" + title,
      });
    }

    /**
     * Common Function to track GA Parameters
     */
    var trackGaEvents = document.getElementsByClassName("track-ga");
    if (trackGaEvents) {
      for (var i = 0; i < trackGaEvents.length; i++) {
        trackGaEvents[i].addEventListener("click", trackGaEventsFn);
      }
    }

    function trackGaEventsFn() {
      var eventCategory = this.getAttribute("data-category");
      var eventAction = this.getAttribute("data-action");
      var eventLabel = this.getAttribute("data-label");

      ga(
        "browserstack.set",
        "dimension7",
        String(Math.round(new Date() / 1000))
      );
      ga("browserstack.send", "event", {
        eventCategory: eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel,
      });
    }

    window.addEventListener("load", function () {
      /**
       * Tabs Js
       * Used in automate/features page
       */
      var verticalTabs = document.getElementById("enable-vertical-tabs");
      if (verticalTabs) {
        var tabsContent = document.getElementById("features-content-tabs");
        if (tabsContent) {
          bsTabs(tabsContent);
        }
      }

      /**
       * BSPageSpeed is an object required for Health Reports
       * 
       */
      if (typeof BSPageSpeed !== "undefined") {
        BSPageSpeed = new BSPageSpeed();
        BSPageSpeed.init();
      }

      /**
       * laoding all the youtube iframe after page load
       * Ref: https://www.minddevelopmentanddesign.com/blog/how-to-defer-parsing-of-javascript-for-youtube-iframe-videos-in-wordpress/
       */
      var vidDefer = document.getElementsByTagName('iframe');
      for (var i=0; i<vidDefer.length; i++) {
        if(vidDefer[i].getAttribute('data-src')) {
          vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
        } 
      } 
      
    });

    /**
     * This is also a part of experiment for the above code.
     * Please remove this once the experiment is over.
     */
    var product_pages = [
        "homepage",
        "live",
        "app-live",
        "automate",
        "app-automate",
        "enterprise",
      ],
      product_page_title,
      homePage = document.getElementById("home-page");
      if (homePage) {
        product_page_title = "homepage";
      } else {
        product_page_title = window.location.pathname.split("/")[1];
      }
    if (product_pages.indexOf(product_page_title) !== -1) {
      if (Cookie) {
        var data = JSON.parse(Cookie.read("p_list"));
        if (data) {
          if (data.indexOf(product_page_title) === -1) {
            data.push(product_page_title);
            Cookie.create("p_list", JSON.stringify(data), 90);
          }
        } else {
          data = [product_page_title];
          Cookie.create("p_list", JSON.stringify(data), 90);
        }
      }
    }

    /**
     * Gauth common custom event with ref url
     * Add google sign on base64 encode
     */
    var customGoogleBtn = document.querySelectorAll('.custom-gauth-btn-main a'),
      currentPageUrl = window.location.href,
      previousPageUrl = (document.referrer !== '') ? document.referrer : 'organic',
      gauth_utm_campaigncode = bsLib.getParameterByName("utm_campaigncode") ? bsLib.getParameterByName("utm_campaigncode") : '';
    
    
    for (var i = 0; i < customGoogleBtn.length; i++) {
      customGoogleBtn[i].setAttribute(
        "href",
        customGoogleBtn[i].getAttribute("href") +
          window.btoa(
            '{"referrer_url":"' + currentPageUrl + '", ' +
            '"utm_campaigncode":"' + gauth_utm_campaigncode + '",' +        
            '"primary_product":"' + pageProductName + '",' +
            '"page_url":"' + currentPageUrl + '",' +
            '"previous_page_url":"' + previousPageUrl + '"}'
        )
      )
    }

    /**
     * Attach standardise & capture the UTM parameters (source, medium, campaign etc) in every anchor tag.
     */
     var paramsValue = {},
     allLinksTag = document.getElementsByTagName("a"),
     whiteListParams = [
      'utm_source',
      'utm_medium',
      'utm_platform',
      'utm_content',
      'utm_campaign',
      'utm_campaigncode',
      'utm_term'
    ],
    paramsObj = window.location.search
    .slice(1)
    .split('&')
    .map(function (p) {
      return p.split('=');
    })
    .reduce(function (obj, pair) {
      if (pair.length >= 2) {
        obj[pair[0]] = pair[1];
      }
      return obj;
    }, {});

    var cookieUtmParams = Cookie.read(stage_env_cookie_prefix + "user_utm_data");
    //Read from cookie
    if (Object.keys(paramsObj).length == 0) {  
      if (cookieUtmParams) {
        paramsObj = bsLib.JSONParse(cookieUtmParams);
      }
    }
    
    // check white list params
    Object.keys(paramsObj).forEach(function (key) {
      if (whiteListParams.indexOf(key) > -1) {
        paramsValue[key] = paramsObj[key];
      }
    });

    //create cookie
    if (Object.keys(paramsValue).length > 0 
      && cookieUtmParams 
      && cookieUtmParams !== JSON.stringify(paramsValue)) {
      Cookie.create(stage_env_cookie_prefix + "user_utm_data", JSON.stringify(paramsValue), 1/48);
    } else if (Object.keys(paramsValue).length > 0 && !cookieUtmParams) {
      Cookie.create(stage_env_cookie_prefix + "user_utm_data", JSON.stringify(paramsValue), 1/48);
    }

    if (Object.keys(paramsValue).length > 0) {
      var queryString = Object.keys(paramsValue).map(function(key) {
        return key + '=' + paramsValue[key]
      }).join('&'),
      allFormsTag = document.getElementsByTagName("form");

      //Update all forms action
      for (var idx = 0; idx < allFormsTag.length; ++idx) {
        if (allFormsTag[idx].action.length == 0) {
          continue;
        }

        if (allFormsTag[idx].action.indexOf("search") >= 0
        || allFormsTag[idx].action.indexOf("user/try-live") >= 0) {
          Object.keys(paramsValue).map(function(key) {
            var checkUTMfield = allFormsTag[idx].querySelector("input[name='"+ key +"']");
            if (checkUTMfield) {
              checkUTMfield.value = paramsValue[key];
            } else {
              var inputElement = document.createElement("input");
              inputElement.type = "hidden";
              inputElement.name = key;
              inputElement.value = paramsValue[key];
              allFormsTag[idx].appendChild(inputElement);
            }
          });
        }
      }

      //update all links
      for (var idx = 0; idx < allLinksTag.length; ++idx) {
        if (allLinksTag[idx].href.length == 0) {
          continue;
        }

        var currParamsObj,
        curLinkParams = allLinksTag[idx].href.split("?"),
        curLinkHashParams = allLinksTag[idx].href.split("#");

        if ( allLinksTag[idx].href.toLowerCase().indexOf("google_oauth") >= 0
          || allLinksTag[idx].href.toLowerCase().indexOf("javascript:void") >= 0
          || allLinksTag[idx].classList.contains("skip-link")
          || allLinksTag[idx].classList.contains("skip-utm-link")
          || !(curLinkParams[0].indexOf(".wpengine.com") >= 0
          || curLinkParams[0].indexOf(".browserstack.com") >= 0
          || curLinkParams[0].indexOf(".bsstag.com") >= 0)
        ) {
          continue;
        }

        //those link have existing params
        if (curLinkParams.length > 1) {
          currParamsObj = curLinkParams[1].split('&').map(function (p) { return p.split('='); }).reduce(function (obj, pair) {
            if (pair.length >= 2) {
              //remove whiteListParams from existing link condition 
              if (whiteListParams.indexOf(pair[0]) < 0) {
                obj[pair[0]] = pair[1].split('#')[0];
              }
            }
            return obj;
          }, {});

          if (Object.keys(currParamsObj).length > 0) {
            var currQueryString = Object.keys(currParamsObj).map(function(key) {
              return key + '=' + currParamsObj[key]
            }).join('&');

            allLinksTag[idx].href = curLinkParams[0].split('#')[0] + "?" + currQueryString + "&" + queryString + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
          } else {
            allLinksTag[idx].href = curLinkParams[0].split('#')[0] + "?" + queryString + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
          }
        } else {
          allLinksTag[idx].href = curLinkParams[0].split('#')[0] + "?" + queryString + (curLinkHashParams.length > 1 ? "#" + curLinkHashParams[1] : "");
        }
      }
    }

    /**
     * Google OAuth method post submit
     */
    var allGOauthLinks = document.querySelectorAll("a.google-goauth-post-method");
    for (var idx = 0; idx < allGOauthLinks.length; ++idx) {
      allGOauthLinks[idx].addEventListener('click', function (e) {
        e.preventDefault();
        
        var that = this,
        gform = document.createElement('form'),
        gHiddenField = document.createElement('input');

        gform.setAttribute('action', that.href);
        gform.setAttribute('method', 'POST');

        gHiddenField.setAttribute('type', 'hidden');
        gHiddenField.setAttribute('name', 'authenticity_token');

        gform.appendChild(gHiddenField);
        gform.style.display = 'none';
        document.getElementsByTagName('body')[0].appendChild(gform);

        //get userToken
        bsLib.ajax(
          "GET",
          bsLib.railsHost() + "/user/token.json",
          {},
          true,
          {},
          // Success message for user token.
          function (data) {
            var dataRequest = bsLib.JSONParse(data.response);
            if (dataRequest) {
              csrf_token = dataRequest.csrf_token;
              gHiddenField.setAttribute('value', csrf_token);

              //submit form
              gform.submit();
            }
          },
          //error
          function () {}
        );

        return false;
      });
    }

    /**
     * Dynamic Pricing Page Exp Cookie for Product LP tracking
     */
    var pageSlug = window.location.pathname,
      productsArray = ['live', 'app-live', 'automate', 'app-automate', 'percy'],
      productPageName = 'live';
    pageSlug = pageSlug.replace(/^\/|\/$/g, "");

    if (productsArray.indexOf(pageSlug) > -1) {
      Cookie.create(stage_env_cookie_prefix + 'last_visited_product_page', pageSlug, 30);
    } else if (Cookie.read(stage_env_cookie_prefix + 'last_visited_product_page') === null) {
      Cookie.create(stage_env_cookie_prefix + 'last_visited_product_page', productPageName, 30);
    }

    /**
     * Percy & App Percy page dashboard link for Signed in state
     */
    var mainProductPage = pageSlug ? pageSlug.split('/')[0] : '',
      internalPage = pageSlug.split('/')[1] ? pageSlug.split('/')[1] : 'landing',
      headerSignInLink = headerFTLink = '';
    
    if (Cookie.read(stage_env_cookie_prefix + "bs_logging_id")) {
      if (mainProductPage === 'percy' || mainProductPage === 'app-percy') {
        var percyProdLinks = document.querySelectorAll('a[href*="/users/sign_up?ref=' + mainProductPage + '"]'),
          mainSubPage = pageSlug.split('/')[1] ? pageSlug.split('/')[1] : 'landing';
        for (var i = 0; i < percyProdLinks.length; i++) {
          percyProdLinks[i].href = 'https://percy.io/dashboard?ref=' + mainProductPage + '-' + mainSubPage + '-page';
        }
      }
      // update header menu FT & SignIn button
      if (mainProductPage === 'app-percy') {
        headerSignInLink = 'https://percy.io/dashboard?ref=' + mainProductPage + '-' + internalPage + '-page-header-signin',
        headerFTLink = 'https://percy.io/dashboard?ref=' + mainProductPage + '-' + internalPage + '-page-header-ft';
        fnUpdateMenuCtaSignedInState(headerSignInLink, headerFTLink);
      } else if (mainProductPage === 'test-management') {
        headerSignInLink = 'https://test-management.browserstack.com/onboarding?ref=' + mainProductPage + '-' + internalPage + '-page-header-signin',
        headerFTLink = 'https://test-management.browserstack.com/onboarding?ref=' + mainProductPage + '-' + internalPage + '-page-header-ft';
        fnUpdateMenuCtaSignedInState(headerSignInLink, headerFTLink);
      } else if (mainProductPage === 'test-observability') {
        headerSignInLink = 'https://observability.browserstack.com?ref=' + mainProductPage + '-' + internalPage + '-page-header-signin',
        headerFTLink = 'https://observability.browserstack.com?ref=' + mainProductPage + '-' + internalPage + '-page-header-ft';
        fnUpdateMenuCtaSignedInState(headerSignInLink, headerFTLink);
      } else if (mainProductPage === 'accessibility-testing') {
        headerSignInLink = 'https://accessibility.browserstack.com?ref=' + mainProductPage + '-' + internalPage + '-page-header-signin',
        headerFTLink = 'https://accessibility.browserstack.com?ref=' + mainProductPage + '-' + internalPage + '-page-header-ft';
        fnUpdateMenuCtaSignedInState(headerSignInLink, headerFTLink);
      }
    }

    function fnUpdateMenuCtaSignedInState(headerSignInLink, headerFTLink) {
      var headerSignInBtn = document.querySelector('.sign-in-link > a'),
        headerFreeTrailBtn = document.getElementById('free-trial-link-anchor'),
        secHeaderFreeTrailBtn = document.getElementById('free-trial-cta'),
        secHeaderSignInBtn = document.getElementById('sign_in_link'),
        mobileFreeTrailBtn = document.getElementById('free-trial-link-anchor-mobile'),
        mobileFreeTrialLink = document.querySelector('.free-trial-link'),
        mobileSignInBtn = mobileFreeTrialLink ? mobileFreeTrialLink.previousElementSibling.children[0] : '';
      
      headerSignInBtn ? headerSignInBtn.href = headerSignInLink : '';
      headerFreeTrailBtn ? headerFreeTrailBtn.href = headerFTLink : '';
      mobileFreeTrailBtn ? mobileFreeTrailBtn.href = (headerFTLink + '-mobile') : '';
      mobileSignInBtn ? mobileSignInBtn.href = (headerSignInLink + '-mobile') : '';
      secHeaderFreeTrailBtn ? secHeaderFreeTrailBtn.href = (headerFTLink + '-sticky') : '';
      secHeaderSignInBtn ? secHeaderSignInBtn.href = (headerSignInLink + '-sticky') : '';
    }

    /**
     * Bitrise partnership page signup Ref param
    */
    var headerSigninLink = document.querySelector('.bstack-mm-main-link-sign-in'),
      headerFreeTrailLink = document.querySelector('.bstack-mm-main-link-free-trial');

    if (mainProductPage === 'bitrise-partnership') {
      headerSigninLink ? (headerSigninLink.href = (headerSigninLink.href + (headerSigninLink.href.indexOf("?") > -1 ? '&' : '?') + 'ref=bitrise-partnership')) : '';
      headerFreeTrailLink ? (headerFreeTrailLink.href = (headerFreeTrailLink.href + (headerFreeTrailLink.href.indexOf("?") > -1 ? '&' : '?') + 'ref=bitrise-partnership')) : '';
    }

    /**
     * Common Function for Scroll to ID on page load
    */
    setTimeout(function () {
      var scrollToSection = window.location.search;
      if (scrollToSection.indexOf('scroll_to=') > -1) {
        var getElemId = bsLib.getParameterByName('scroll_to'),
          promoBarElem = document.getElementsByClassName("promo-notification")[0] ? document.getElementsByClassName("promo-notification")[0].offsetHeight : 0,
          headerElem = document.getElementById("header-habitat") ? document.getElementById("header-habitat").offsetHeight : 0,
          headerHeight = headerElem + promoBarElem,
          getMainElem = document.querySelector("[id=" + "\'" + getElemId + "\'" + "]"),
          refSlug = '';

        if (scrollToSection.indexOf('?ref=') > -1) {
          refSlug = window.location.search.split('&')[0];
        }
        
        if (getMainElem) {
          var activeLinkElem = document.querySelector('.nested-scrollto-link a[href*="?scroll_to=' + getElemId + '"]'),
            offsetTop = getMainElem.offsetTop - headerHeight;
          
          if (refSlug) {
            activeLinkElem = document.querySelector('.nested-scrollto-link a[href*="'+ refSlug + '&scroll_to=' + getElemId + '"]');
          }

          var activeParentLinkElem = activeLinkElem ? activeLinkElem.closest('.custom-nested-secondary-nav.nested-dd-menu'): null,
            activeMainParentLinkElem = activeParentLinkElem ? activeParentLinkElem.closest('.secondary-nav__nested-menu') : null;

          activeLinkElem ? activeLinkElem.classList.add('active-nested-link') : '';
          activeParentLinkElem ? activeParentLinkElem.classList.add('current-menu-parent', 'active') : '';
          activeMainParentLinkElem ? activeMainParentLinkElem.parentElement.classList.add('current-menu-parent', 'active') : '';

          bsLib.scrollIt(
            offsetTop,
            700
          );
        }
      } else if (scrollToSection.indexOf('?ref=') > -1) {
        var refSlug = '';
        refSlug = window.location.search.split('&')[0];

        if (refSlug) {
          var activeLinkElem = document.querySelector('.custom-nested-secondary-nav a[href*="'+ refSlug + '"]'),
            activeParentLinkElem = activeLinkElem ? activeLinkElem.closest('.custom-nested-secondary-nav.nested-dd-menu'): null,
            activeMainParentLinkElem = activeParentLinkElem ? activeParentLinkElem.closest('.secondary-nav__nested-menu') : null;

          activeLinkElem ? activeLinkElem.classList.add('active-nested-link') : '';
          activeParentLinkElem ? activeParentLinkElem.classList.add('current-menu-parent', 'active') : '';
          activeMainParentLinkElem ? activeMainParentLinkElem.parentElement.classList.add('current-menu-parent', 'active') : '';
        }
      }
    }, 500);

    /**
     * Load script on event action
     */
    Object.keys(loadScriptEvtSelctor).forEach(function (key, idx) {
      var selctorEvt = document.querySelectorAll(key);
      if (selctorEvt.length > 0) {
        for (var z = 0; z < selctorEvt.length; z++) {
          if (selctorEvt[z]) {
            selctorEvt[z].addEventListener("mouseover", function () {
              scriptLoaded(idx, key);
            });
            selctorEvt[z].addEventListener("click", function () {
              scriptLoaded(idx, key);
            });
            selctorEvt[z].addEventListener("touchstart", function () {
              scriptLoaded(idx, key);
            });
          }
        }
      }
    });

    //Focus Elelment
    var focusableElements = 'iframe, [href], input, select, textarea, button, [tabindex]:not([tabindex="-1"])',
    focusableElementsSel = document.querySelectorAll(focusableElements);

    for (var z = 0; z < focusableElementsSel.length; z++) {
      if (focusableElementsSel[z]) {
        focusableElementsSel[z].addEventListener("focus", function () {
          Object.keys(loadScriptEvtSelctor).forEach(function (key, idx) {
            scriptLoaded(idx, key);
          });
        });
      }
    }
    /**
     * END
     */
  };

  function scriptLoaded(idx, key) {
    Object.keys(loadScriptEvtSelctor[key]).forEach(function (key2, idx2) {
      if (key2 == "JS") {
        for (var index = 0; index < loadScriptEvtSelctor[key][key2].length; index++) {
          var loadScriptIdx = document.getElementById('load-script-idx' + idx + "" + idx2 + "" + index);
          if (!loadScriptIdx) {
            var script = document.createElement('script');
            script.src = loadScriptEvtSelctor[key][key2][index];
            script.id = 'load-script-idx' + idx + "" + idx2 + "" + index;
            script.defer = "defer";
            document.getElementsByTagName('head')[0].appendChild(script);
          }
        }
      } else if (key2 == "CSS") {
        for (var index = 0; index < loadScriptEvtSelctor[key][key2].length; index++) {
          var loadScriptIdx = document.getElementById('load-style-idx' + idx + "" + idx2 + "" + index);
          if (!loadScriptIdx) {
            var link  = document.createElement('link');
            link.id   = 'load-style-idx' + idx + "" + idx2 + "" + index;
            link.rel  = 'stylesheet';
            link.type = 'text/css';
            link.href = loadScriptEvtSelctor[key][key2][index];
            link.media = 'all';
            document.getElementsByTagName('head')[0].appendChild(link);
          }
        }
      }
    });
  }
})();

scriptsJs.init();